import payables from '~/modules/payables/translations';
import shipment from '~/modules/shipment/translations';
import shipper from '~/modules/shipper/translations';
import transporter from '~/modules/transporter/translations';

import common from './en_common';
import compose from './en_compose';
import form from './en_form';
import network from './en_network';
import sentence from './en_sentence';
import translations from './en_translations';

export default {
  common,
  compose,
  form,
  network,
  payables: payables?.en,
  sentence,
  shipment: shipment?.en,
  shipper: shipper?.en,
  transporter: transporter?.en,
  translations,
} as const;
